import { render, staticRenderFns } from "./LAlumni.vue?vue&type=template&id=1f9b825a&scoped=true&"
import script from "./LAlumni.vue?vue&type=script&lang=js&"
export * from "./LAlumni.vue?vue&type=script&lang=js&"
import style0 from "./LAlumni.vue?vue&type=style&index=0&id=1f9b825a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9b825a",
  null
  
)

export default component.exports